export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  // Platform (Resource Admin)
  'menu.resource-admin': 'Platform Admin',
  'menu.resource-admin.dashboard': 'Dashboard',
  'menu.resource-admin.resource': 'Resources',
  'menu.resource-admin.resource.menus': 'Menus',
  'menu.resource-admin.resource.roles': 'Roles',
  'menu.resource-admin.resource.resources': 'Resources',
  'menu.resource-admin.resource.resource-types': 'Resource Types',
  'menu.resource-admin.saas': 'SaaS',
  'menu.resource-admin.saas.tenants': 'Tenants',
  'menu.resource-admin.saas.applications': 'Applications',
  'menu.resource-admin.saas.tenant-applications': 'Tenant Apps',
  'menu.resource-admin.saas.app-configs': 'App Configs',
  'menu.resource-admin.saas.certifications': 'Certifications',
  'menu.resource-admin.saas.registration-config': 'Registration Config',
  'menu.resource-admin.saas.registration-statistics': 'Registration Stats',
  'menu.resource-admin.saas.inactive-tenants': 'Inactive Reminders',
  'menu.resource-admin.message': 'Messaging',
  'menu.resource-admin.message.subscriptions': 'Subscriptions',
  'menu.resource-admin.message.templates': 'Templates',
  'menu.resource-admin.payment': 'Payment',
  'menu.resource-admin.payment.payment-channels': 'Payment Channels',
  'menu.resource-admin.payment.currencies': 'Currencies',
  // Platform Wallet (Currencies only)
  'menu.resource-admin.wallet': 'Wallet',
  'menu.resource-admin.wallet.currencies': 'Currencies',
  'menu.resource-admin.authn': 'Authentication',
  'menu.resource-admin.authn.oauth2-clients': 'OAuth Clients',
  'menu.resource-admin.authn.oauth2-scopes': 'OAuth Scopes',
  'menu.resource-admin.authn.user-agreements': 'User Agreements',
  'menu.resource-admin.authn.account-cancellations': 'Account Cancellations',
  'menu.resource-admin.saas-ext': 'SaaS',
  'menu.resource-admin.saas-ext.app-domains': 'App Domains',
  'menu.resource-admin.saas-ext.tenant-logs': 'Tenant Logs',
  // SaaS Platform
  'menu.saas-platform': 'SaaS Platform',
  'menu.saas-platform.workbench': 'Workbench',
  'menu.saas-platform.workbench.dashboard': 'Platform Overview',
  'menu.saas-platform.workbench.notifications': 'Notifications',
  'menu.saas-platform.workbench.my-messages': 'My Messages',
  'menu.saas-platform.workbench.support': 'Help & Support',
  'menu.saas-platform.app-center': 'App Center',
  'menu.saas-platform.app-center.market': 'App Market',
  'menu.saas-platform.app-center.subscribed': 'Subscribed Apps',
  'menu.saas-platform.app-center.tenant-settings': 'Tenant Settings',
  'menu.saas-platform.app-center.app-configs': 'App Configs',
  'menu.saas-platform.management': 'Platform Management',
  'menu.saas-platform.management.tenant-app': 'Tenants & Apps',
  'menu.saas-platform.management.tenant-app.tenants': 'Tenants',
  'menu.saas-platform.management.tenant-app.tenant-applications': 'Tenant Apps',
  'menu.saas-platform.management.tenant-app.app-configs': 'Tenant App Configs',
  'menu.saas-platform.management.platform-management': 'Platform Management',
  'menu.saas-platform.management.platform-management.users': 'Platform Users',
  'menu.saas-platform.management.platform-management.roles': 'Platform Roles',
  'menu.saas-platform.management.account-auth': 'Account & Permissions',
  'menu.saas-platform.management.account-auth.users': 'Users',
  'menu.saas-platform.management.account-auth.user-detail': 'User Detail',
  'menu.saas-platform.management.account-auth.roles': 'Roles',
  'menu.saas-platform.management.account-auth.permission-templates':
    'Permission Templates',
  'menu.saas-platform.management.account-auth.data-permission-templates':
    'Data Permission Templates',
  'menu.saas-platform.management.account-auth.user-login-history':
    'User Login History',
  'menu.saas-platform.apps': 'Platform Apps',
  // CMS Module
  'menu.cms': 'Content Management',
  'menu.cms.sites': 'Sites',
  'menu.cms.channels': 'Channels',
  'menu.cms.articles': 'Articles',
  'menu.cms.link-exchanges': 'Link Exchanges',
  'menu.cms.templates': 'Templates',
  // Billing Module
  'menu.billing': 'Billing',
  'menu.billing.products': 'Products',
  'menu.billing.product-plans': 'Product Plans',
  'menu.billing.orders': 'Orders',
  'menu.billing.subscriptions': 'Subscriptions',
  'menu.billing.invoices': 'Invoices',
  'menu.billing.payment-config': 'Payment Config',
  'menu.billing.webhook-endpoints': 'Webhook Config',
  'menu.billing.change-plan-for-user': 'Change Subscription Plan',
  'billing.payment-config.merchant-id': 'Merchant ID',
  'billing.payment-config.callback-domain': 'Callback Domain',
  'billing.payment-config.status': 'Status',
  'billing.payment-config.status-enabled': 'Enabled',
  'billing.payment-config.status-disabled': 'Disabled',
  'billing.payment-config.merchant-id-required': 'Please enter merchant ID',
  'billing.payment-config.callback-domain-required':
    'Please enter callback domain',
  'billing.payment-config.update-success': 'Config updated successfully',
  'billing.payment-config.create-success': 'Config created successfully',
  'billing.payment-config.operation-failed': 'Operation failed',
  // Affiliate Module
  'menu.affiliate': 'Affiliate',
  'menu.affiliate.stats': 'Overview',
  'menu.affiliate.promoters': 'Promoters',
  'menu.affiliate.applications': 'Applications',
  'menu.affiliate.commissions': 'Commissions',
  'menu.affiliate.links': 'Referral Links',
  'menu.affiliate.my-profile': 'My Profile',
  'menu.affiliate.my-links': 'My Links',
  'menu.affiliate.my-team': 'My Team',
  'menu.affiliate.my-commissions': 'My Commissions',
  'menu.affiliate.my-level': 'My Level',
  'menu.affiliate.commission-rules': 'Commission Rules',
  'menu.affiliate.leader-dashboard': 'Leader Dashboard',
  'menu.affiliate.team-members': 'Team Members',
  'menu.affiliate.bonus-pool': 'Bonus Pool',
  'menu.affiliate.webhook-subscriptions': 'Webhook Subscriptions',
  // Payment Module
  'menu.payment': 'Payment',
  'menu.payment.orders': 'Payment Orders',
  'menu.payment.transactions': 'Transactions',
  'menu.payment.merchants': 'Merchants',
  'menu.payment.merchant-channels': 'Merchant Channels',
  'menu.payment.payment-config': 'Payment Config',
  'payment.payment-config.domain-id': 'Domain',
  'payment.payment-config.status': 'Status',
  'payment.payment-config.status-enabled': 'Enabled',
  'payment.payment-config.status-disabled': 'Disabled',
  'payment.payment-config.domain-id-required': 'Please select a domain',
  'payment.payment-config.update-success': 'Config updated successfully',
  'payment.payment-config.create-success': 'Config created successfully',
  'payment.payment-config.operation-failed': 'Operation failed',
  // Message Module
  'menu.message': 'Message',
  'menu.message.senders': 'Senders',
  'menu.message.history': 'History',
  'menu.message.user-subscriptions': 'User Subscriptions',
  'menu.message.user-channels': 'User Channels',
  'menu.message.blacklists': 'Blacklists',
  // OSS Module
  'menu.oss': 'Storage',
  'menu.oss.files': 'Files',
  'menu.oss.buckets': 'Buckets',
  'menu.oss.app-storages': 'App Storages',
  // Authn Module
  'menu.authn': 'Authentication',
  'menu.authn.username-blacklists': 'Username Blacklist',
  'menu.authn.app-config': 'App Config',
  'menu.authn.agreements': 'Agreements',
  'menu.authn.agreements-create': 'Create Agreement',
  'menu.authn.agreements-detail': 'Agreement Detail',
  'menu.authn.agreements-edit': 'Edit Agreement',
  'menu.saas-platform.ops': 'Platform Ops',
  'menu.saas-platform.ops.resources': 'Resource Orchestration',
  'menu.saas-platform.ops.resources.menus': 'Menus',
  'menu.saas-platform.ops.resources.list': 'Resource List',
  'menu.saas-platform.ops.resources.detail': 'Resource Detail',
  'menu.saas-platform.ops.resources.types': 'Resource Types',
  'menu.saas-platform.ops.global-capabilities': 'Global Capabilities',
  'menu.saas-platform.ops.global-capabilities.message-subscriptions':
    'Subscriptions',
  'menu.saas-platform.ops.global-capabilities.message-templates': 'Templates',
  'menu.saas-platform.ops.global-capabilities.payment-channels':
    'Payment Channels',
  'menu.saas-platform.ops.global-capabilities.payment-currencies':
    'Payment Currencies',
  'menu.saas-platform.ops.global-capabilities.wallet-currencies':
    'Wallet Currencies',
  'menu.saas-platform.ops.global-capabilities.crontab': 'Crontab',
  'menu.saas-platform.ops.global-capabilities.crontab.jobs': 'Jobs',
  'menu.saas-platform.ops.global-capabilities.crontab.cron-expressions':
    'Cron Expressions',
  'menu.saas-platform.ops.global-capabilities.crontab.schedulers': 'Schedulers',
  'menu.saas-platform.ops.global-capabilities.crontab.workers': 'Workers',
  'menu.saas-platform.ops.security-logs': 'Security & Logs',
  'menu.saas-platform.ops.security-logs.platform-security-alerts':
    'Platform Security Alerts',
  'menu.saas-platform.ops.security-logs.audit-logs': 'Audit Logs',
  'menu.saas-platform.ops.security-logs.webhook-logs': 'Webhook Logs',
  'menu.saas-platform.ops.security-logs.access-logs': 'Access Logs',
  'menu.saas-platform.task-center': 'Task Center',
  'menu.saas-platform.task-center.tasks': 'Task Management',
  'menu.saas-platform.task-center.media-convert': 'Media Convert',
  'menu.saas-platform.system.billing': 'Subscription Settings',
  'menu.saas-platform.system.billing.payment-config':
    'Subscription Payment Config',
  'menu.saas-platform.system.billing.webhook-endpoints': 'Webhook Config',
  'menu.saas-platform.system.affiliate': 'Affiliate Settings',
  'menu.saas-platform.system.affiliate.webhook-subscriptions':
    'Webhook Subscriptions',
  'menu.saas-platform.system.wallet': 'Wallet Settings',
  'menu.saas-platform.system.wallet.config': 'Wallet Config',
  'menu.saas-platform.system.wallet.security': 'Security',
  'menu.saas-platform.system.wallet.fee-rules': 'Fee Rules',
  'menu.saas-platform.system.wallet.risk-rules': 'Risk Rules',
  'menu.saas-platform.system.wallet.limit-config': 'Limits',
  'menu.saas-platform.system.wallet.webhooks': 'Webhooks',
  'menu.saas-platform.system.wallet.credentials': 'API Credentials',
  'menu.saas-platform.system.wallet.blacklists': 'API Blacklists',
  'menu.saas-platform.system.app-settings': 'App Settings',
  'menu.saas-platform.system.customer-service': 'Customer Service Config',
  'menu.saas-platform.account': 'Account',
  'menu.saas-platform.account.profile': 'Profile',
  'menu.saas-platform.account.security': 'Security',
  'menu.saas-platform.account.login-history': 'Login History',
  'menu.saas-platform.account.preferences': 'Preferences',
  'menu.saas-platform.account.bindings': 'Account Bindings',
  'menu.saas-platform.account.notifications': 'Notifications',
  'menu.saas-platform.account.my-messages': 'My Messages',
  // App Basic
  'menu.app-basic': 'App Basic',
  'menu.app-basic.iam': 'IAM',
  'menu.app-basic.iam.users': 'Users',
  'menu.app-basic.iam.roles': 'Roles',
  'menu.app-basic.iam.organizations': 'Organizations',
  'menu.app-basic.iam.positions': 'Positions',
  'menu.app-basic.iam.data-permission-templates': 'Data Permission Templates',
  'menu.app-basic.iam.permission-templates': 'Permission Templates',
  'menu.app-basic.iam.security-alerts': 'Security Alerts',
  'menu.app-basic.iam.devices': 'Devices',
  'menu.app-basic.oss': 'File Storage',
  'menu.app-basic.oss.files': 'Files',
  'menu.app-basic.oss.storages': 'Storages',
  'menu.app-basic.oss.app-storages': 'App Storages',
  'menu.app-basic.oss.image-styles': 'Image Styles',
  'menu.app-basic.oss.cdn-config': 'CDN Config',
  'menu.app-basic.oss.multipart-uploads': 'Multipart Uploads',
  'menu.app-basic.message': 'Messaging',
  'menu.app-basic.message.senders': 'Senders',
  'menu.app-basic.message.app-config': 'App Config',
  'menu.app-basic.message.history': 'History',
  'menu.app-basic.message.email-records': 'Email Records',
  'menu.app-basic.message.phone-records': 'SMS Records',
  'menu.app-basic.message.user-channels': 'User Channels',
  'menu.app-basic.message.user-subscriptions': 'User Subscriptions',
  'menu.app-basic.message.blacklists': 'Blacklists',
  'menu.app-basic.message.dead-letters': 'Dead Letters',
  'menu.app-basic.message.push-devices': 'Push Devices',
  'menu.app-basic.billing': 'Billing',
  'menu.app-basic.billing.products': 'Products',
  'menu.app-basic.billing.subscriptions': 'Subscriptions',
  'menu.app-basic.billing.orders': 'Orders',
  'menu.app-basic.billing.invoices': 'Invoices',
  'menu.app-basic.billing.features': 'Features',
  'menu.app-basic.billing.coupons': 'Coupons',
  'menu.app-basic.billing.usage': 'Usage',
  'menu.app-basic.billing.wallets': 'Wallets',
  'menu.app-basic.billing.wallet-ledgers': 'Wallet Ledgers',
  'menu.app-basic.billing.coupon-codes': 'Coupon Codes',
  'menu.app-basic.billing.coupon-redemptions': 'Redemptions',
  'menu.app-basic.payment': 'Payment',
  'menu.app-basic.payment.orders': 'Orders',
  'menu.app-basic.payment.transactions': 'Transactions',
  'menu.app-basic.payment.merchant-config': 'Merchant Config',
  'menu.app-basic.payment.merchant': 'Merchant',
  'menu.app-basic.payment.merchant.payment-channels':
    'Merchant Payment Channels',
  'menu.app-basic.payment.channels': 'Payment Channels',
  'menu.app-basic.payment.currencies': 'Currencies',
  'menu.app-basic.payment.reconciliations': 'Reconciliations',
  'menu.app-basic.payment.risk-rules': 'Risk Rules',
  'menu.app-basic.payment.risk-records': 'Risk Records',
  'menu.app-basic.payment.webhook-logs': 'Webhook Logs',
  'menu.app-basic.cms': 'Content',
  'menu.app-basic.cms.sites': 'Sites',
  'menu.app-basic.cms.channels': 'Channels',
  'menu.app-basic.cms.articles': 'Articles',
  'menu.app-basic.cms.albums': 'Albums',
  'menu.app-basic.cms.carousel': 'Carousel',
  'menu.app-basic.cms.sensitive-words': 'Sensitive Words',
  'menu.app-basic.cms.guestbooks': 'Guestbooks',
  'menu.app-basic.cms.content-reviews': 'Content Reviews',
  'menu.app-basic.cms.templates': 'Templates',
  'menu.app-basic.cms.link-exchanges': 'Link Exchanges',
  // Wechat
  'menu.app-basic.wechat': 'WeChat',
  'menu.app-basic.wechat.menus': 'Menus',
  'menu.app-basic.wechat.materials': 'Materials',
  'menu.app-basic.wechat.messages': 'Messages',
  // Media Convert
  'menu.app-basic.media-convert': 'Media Convert',
  'menu.app-basic.media-convert.tasks': 'Transcode Tasks',
  // Tenant SaaS
  'menu.app-basic.saas': 'SaaS Config',
  'menu.app-basic.saas.settings': 'Tenant Settings',
  'menu.app-basic.saas.app-configs': 'App Configs',
  'menu.app-basic.saas.audit-logs': 'Audit Logs',
  // Tenant Wallet
  'menu.app-basic.wallet': 'Wallet',
  'menu.app-basic.wallet.wallets': 'Wallets',
  'menu.app-basic.wallet.accounts': 'Accounts',
  'menu.app-basic.wallet.transactions': 'Transactions',
  'menu.app-basic.wallet.account-logs': 'Account Logs',
  'menu.app-basic.wallet.operations': 'Operations',
  'menu.app-basic.wallet.withdraw-orders': 'Withdraw Orders',
  'menu.app-basic.wallet.statistics': 'Statistics',
  'menu.app-basic.wallet.external-accounts': 'External Accounts',
  'menu.app-basic.wallet.webhooks': 'Webhooks',
  'menu.app-basic.wallet.security': 'Security',
  'menu.app-basic.wallet.credentials': 'API Credentials',
  'menu.app-basic.wallet.reconciliation': 'Reconciliation',
  'menu.app-basic.wallet.fee-rules': 'Fee Rules',
  'menu.app-basic.wallet.risk-rules': 'Risk Rules',
  'menu.app-basic.wallet.limit-config': 'Limits',
  'menu.app-basic.wallet.batch-operations': 'Batch Operations',
  'menu.app-basic.wallet.points-expiry': 'Points Expiry',
  'menu.app-basic.wallet.reversals': 'Reversals',
  'menu.app-basic.wallet.config': 'Wallet Config',
  'menu.app-basic.wallet.blacklists': 'API Blacklists',
  'menu.app-basic.wallet.access-logs': 'Access Logs',
  'menu.app-basic.wallet.recharge-applications': 'Recharge Applications',
  // Wallet (route-level)
  'menu.wallet': 'Wallet',
  'menu.wallet.wallets': 'Wallets',
  'menu.wallet.accounts': 'Accounts',
  'menu.wallet.transactions': 'Transactions',
  'menu.wallet.account-logs': 'Account Logs',
  'menu.wallet.operations': 'Operations',
  'menu.wallet.withdraw-orders': 'Withdraw Orders',
  'menu.wallet.statistics': 'Statistics',
  'menu.wallet.external-accounts': 'External Accounts',
  'menu.wallet.webhooks': 'Webhooks',
  'menu.wallet.security': 'Security',
  'menu.wallet.credentials': 'API Credentials',
  'menu.wallet.reconciliation': 'Reconciliation',
  'menu.wallet.fee-rules': 'Fee Rules',
  'menu.wallet.risk-rules': 'Risk Rules',
  'menu.wallet.limit-config': 'Limits',
  'menu.wallet.batch-operations': 'Batch Operations',
  'menu.wallet.points-expiry': 'Points Expiry',
  'menu.wallet.reversals': 'Reversals',
  'menu.wallet.config': 'Wallet Config',
  'menu.wallet.blacklists': 'API Blacklists',
  'menu.wallet.access-logs': 'Access Logs',
  'menu.wallet.recharge-applications': 'Recharge Applications',
  // My Messages
  'menu.my-messages': 'My Messages',
  // My Wallet
  'menu.my-wallet': 'My Wallet',
  // Message Operating
  'menu.message-operating': 'Message Operating',
  'menu.message-operating.campaigns': 'Campaigns',
  'menu.message-operating.segments': 'User Segments',
  'menu.message-operating.scheduled': 'Scheduled Messages',
  'menu.message-operating.ab-tests': 'A/B Tests',
  'menu.message-operating.stats': 'Statistics',
  // Exception pages
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  // Account
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.logout': 'Logout',
  'menu.account.profile': 'Profile',
  'menu.account.security': 'Security',
  'menu.account.certification': 'Enterprise Certification',
  'menu.account.notifications': 'Notifications',
  'menu.account.login-history': 'Login History',
  'menu.account.preferences': 'Preferences',
  'menu.account.bindings': 'Account Bindings',
  'menu.account.recharge-application': 'Recharge Application',
  'menu.account.my-wallet': 'My Wallet',
  // Dynamic menus (backend returns Chinese names, locale key format: "menu.{backend name}")
  // ProLayout auto-generates "menu.{name}" as formatMessage id
  // Falls back to the raw backend name if no matching key is found
  'menu.系统': 'System',
  'menu.应用': 'Applications',
  'menu.用户管理': 'User Management',
  'menu.用户列表': 'User List',
  'menu.角色管理': 'Role Management',
  'menu.权限管理': 'Permissions',
  'menu.报表': 'Reports',
  'menu.审计日志': 'Audit Log',
  'menu.设置': 'Settings',
  'menu.常规设置': 'General Settings',
  'menu.系统设置': 'System Settings',
  'menu.菜单管理': 'Menu Management',
  'menu.资源管理': 'Resource Management',
  'menu.租户管理': 'Tenant Management',
  'menu.应用管理': 'Application Management',
  'menu.资源类型': 'Resource Types',
  // CDN Ops System
  'menu.cdn-ops': 'CDN Ops',
  'menu.cdn-ops.dashboard': 'Dashboard',
  'menu.cdn-ops.sites': 'Site Management',
  'menu.cdn-ops.site-detail': 'Site Detail',
  'menu.cdn-ops.nodes': 'Node Management',
  'menu.cdn-ops.nodes.node-detail': 'Node Detail',
  'menu.cdn-ops.nodes.node-default-config': 'Default Config',
  'menu.cdn-ops.nodes.node-detail-feature': 'Node Detail',
  'menu.cdn-ops.node-ips': 'Node IP Management',
  'cdn.node.sideMenu.group.basic': 'Node Info',
  'cdn.node.sideMenu.backToList': 'Back to Node List',
  'cdn.node.tab.basic': 'Basic Info',
  'cdn.node.tab.config': 'Config Management',
  'cdn.node.tab.stats': 'Traffic Stats',
  'menu.cdn-ops.lines': 'Line Management',
  'menu.cdn-ops.lines.line-detail': 'Line Detail',
  'menu.cdn-ops.lines.line-detail-feature': 'Line Detail',
  'menu.cdn-ops.dns': 'DNS Management',
  'menu.cdn-ops.monitor': 'Monitor',
  'menu.cdn-ops.bigscreen': 'Big Screen',
  'menu.cdn-oper.workbench-bigscreen': 'Big Screen',
  // CDN Ops - Tab descriptions
  'cdn.node.tab.desc.basic':
    'View basic node information including device code, IP addresses, region, and status.',
  'cdn.node.tab.desc.config':
    'Manage node configuration parameters, supporting inheritance from global defaults or custom node-specific configurations.',
  'cdn.node.tab.desc.stats':
    'View node traffic statistics including request volume, bandwidth, and cache hit rate.',
  // CDN Ops - Node status
  'cdn.node.status.active': 'Active',
  'cdn.node.status.inactive': 'Inactive',
  'cdn.node.status.expired': 'Expired',
  'cdn.node.status.pending': 'Pending',
  'cdn.node.status.online': 'Online',
  'cdn.node.status.offline': 'Offline',
  // CDN Ops - Common actions
  'cdn.common.back': 'Back',
  'cdn.common.refresh': 'Refresh',
  // CDN Oper System
  'menu.cdn-oper': 'CDN Oper',
  'menu.cdn-oper.sites': 'Site Management',
  'menu.cdn-oper.site-detail': 'Site Detail',
  // ===== CDN Operations System =====
  // Workbench
  'menu.cdn-oper.workbench': 'Workbench',
  'menu.cdn-oper.workbench.dashboard': 'CDN Overview',
  'menu.cdn-oper.workbench.admin-dashboard': 'Admin Dashboard',
  'menu.cdn-oper.workbench.notifications': 'System Notifications',
  'menu.cdn-oper.workbench.messages': 'My Messages',
  'menu.cdn-oper.workbench.support': 'Help & Support',
  // CMS
  'menu.cdn-oper.cms': 'Website Management',
  'menu.cdn-oper.cms.sites': 'Sites',
  'menu.cdn-oper.cms.channels': 'Channels',
  'menu.cdn-oper.cms.articles': 'Articles',
  'menu.cdn-oper.cms.albums': 'Albums',
  'menu.cdn-oper.cms.carousel': 'Carousel',
  'menu.cdn-oper.cms.carousel-groups': 'Carousel Groups',
  'menu.cdn-oper.cms.link-exchanges': 'Link Exchanges',
  'menu.cdn-oper.cms.guestbooks': 'Guestbooks',
  'menu.cdn-oper.cms.content-reviews': 'Content Reviews',
  'menu.cdn-oper.cms.sensitive-words': 'Sensitive Words',
  // Auth
  'menu.cdn-oper.auth': 'Account & Permissions',
  'menu.cdn-oper.auth.users': 'Users',
  'menu.cdn-oper.auth.roles': 'Roles',
  'menu.cdn-oper.auth.user-login-history': 'Login History',
  // Billing
  'menu.cdn-oper.billing': 'Billing',
  'menu.cdn-oper.billing.products': 'Products',
  'menu.cdn-oper.billing.features': 'Features',
  'menu.cdn-oper.billing.subscriptions': 'Subscriptions',
  'menu.cdn-oper.billing.orders': 'Orders',
  'menu.cdn-oper.billing.usage': 'Usage',
  'menu.cdn-oper.billing.coupons': 'Coupons',
  'menu.cdn-oper.billing.invoices': 'Invoices',
  'menu.cdn-oper.billing.payment-config': 'Payment Config',
  'menu.cdn-oper.billing.my-subscriptions': 'My Subscriptions',
  'menu.cdn-oper.billing.my-orders': 'My Orders',
  'menu.cdn-oper.billing.my-invoices': 'My Invoices',
  'menu.cdn-oper.billing.my-usage': 'My Usage',
  // Payment
  'menu.cdn-oper.payment': 'Payment & Finance',
  'menu.cdn-oper.payment.trades': 'Transactions',
  'menu.cdn-oper.payment.merchants': 'Merchants',
  'menu.cdn-oper.payment.merchant-channels': 'Merchant Channels',
  // Message
  'menu.cdn-oper.message': 'Messages',
  'menu.cdn-oper.message.senders': 'Senders',
  'menu.cdn-oper.message.history': 'History',
  'menu.cdn-oper.message.user-subscriptions': 'User Subscriptions',
  'menu.cdn-oper.message.user-channels': 'User Channels',
  'menu.cdn-oper.message.blacklists': 'Blacklists',
  // Task Center (New)
  'menu.cdn-oper.task-center': 'Task Center',
  'menu.cdn-oper.task-center.tasks': 'Tasks',
  'menu.cdn-oper.task-center.media-convert': 'Media Convert',
  // Authn (New)
  'menu.cdn-oper.authn': 'Auth Config',
  'menu.cdn-oper.authn.username-blacklists': 'Username Blacklists',
  'menu.cdn-oper.authn.app-config': 'App Config',
  'menu.cdn-oper.authn.agreements': 'Agreements',
  // System
  'menu.cdn-oper.system': 'System',
  'menu.cdn-oper.system.app-settings': 'App Settings',
  'menu.cdn-oper.system.customer-service': 'Customer Service Config',
  'menu.cdn-oper.system.files': 'Files',
  'menu.cdn-oper.system.storages': 'Storages',
  'menu.cdn-oper.system.app-storages': 'App Storages',
  'menu.cdn-oper.system.billing': 'Subscription Settings',
  'menu.cdn-oper.system.billing.payment-config': 'Subscription Payment Config',
  'menu.cdn-oper.system.billing.webhook-endpoints': 'Webhook Config',
  'menu.cdn-oper.system.affiliate': 'Affiliate Settings',
  'menu.cdn-oper.system.affiliate.webhook-subscriptions':
    'Webhook Subscriptions',
  'menu.cdn-oper.system.wallet': 'Wallet Settings',
  'menu.cdn-oper.system.wallet.config': 'Wallet Config',
  'menu.cdn-oper.system.wallet.security': 'Security',
  'menu.cdn-oper.system.wallet.fee-rules': 'Fee Rules',
  'menu.cdn-oper.system.wallet.risk-rules': 'Risk Rules',
  'menu.cdn-oper.system.wallet.limit-config': 'Limits',
  'menu.cdn-oper.system.wallet.webhooks': 'Webhooks',
  'menu.cdn-oper.system.wallet.credentials': 'API Credentials',
  'menu.cdn-oper.system.wallet.blacklists': 'API Blacklists',
  // Account
  'menu.cdn-oper.account': 'Account',
  'menu.cdn-oper.account.profile': 'Profile',
  'menu.cdn-oper.account.security': 'Security',
  'menu.cdn-oper.account.login-history': 'Login History',
  'menu.cdn-oper.account.preferences': 'Preferences',
  'menu.cdn-oper.account.bindings': 'Account Bindings',
  'menu.cdn-oper.account.recharge-application': 'Recharge Application',
  // CDN Operations - Hidden Pages
  'menu.cdn-oper.site-create': 'Create Site',
  'menu.cdn-oper.site-detail-feature': 'Site Feature Detail',
  'menu.cdn-oper.cms.article-create': 'Create Article',
  'menu.cdn-oper.cms.article-edit': 'Edit Article',
  'menu.cdn-oper.cms.article-preview': 'Preview Article',
  'menu.cdn-oper.cms.album-create': 'Create Album',
  'menu.cdn-oper.cms.album-edit': 'Edit Album',
  'menu.cdn-oper.cms.album-preview': 'Preview Album',
  'menu.cdn-oper.authn.agreement-create': 'Create Agreement',
  'menu.cdn-oper.authn.agreement-detail': 'Agreement Detail',
  'menu.cdn-oper.authn.agreement-edit': 'Edit Agreement',
  // Cloak - Protection Rules
  'menu.cloak': 'Cloaking',
  'menu.cloak.sites': 'Sites',
  'menu.cloak.sites.create': 'Create Site',
  'menu.cloak.sites.detail': 'Site Detail',
  'menu.cloak.rule-templates': 'Rule Templates',
  'menu.cloak.dashboard': 'Dashboard',
  'menu.cloak.visit-logs': 'Visit Logs',
  'menu.cloak.visit-stats': 'Visit Statistics',

  // Cloak - Account & Permissions
  'menu.cloak.auth': 'Account & Permissions',
  'menu.cloak.auth.users': 'Users',
  'menu.cloak.auth.roles': 'Roles',
  'menu.cloak.auth.user-group-types': 'User Group Types',
  'menu.cloak.auth.user-groups': 'User Groups',
  'menu.cloak.auth.role-group-types': 'Role Group Types',
  'menu.cloak.auth.role-groups': 'Role Groups',
  // Cloak - System Settings
  'menu.cloak.system-app-settings': 'App Settings',
  'menu.cloak.system-oss-files': 'Files',
  'menu.cloak.system-oss-storages': 'Storage Config',
  'menu.cloak.system-oss-app-storages': 'App Storage',
  'menu.cloak.system-oss-config': 'OSS Config',
  'menu.cloak.system-authn-username-blacklists': 'Username Blacklist',
  'menu.cloak.system-authn-app-config': 'Auth Config',
  // Cloak - Account Center
  'menu.cloak.account-profile': 'Profile',
  'menu.cloak.account-security': 'Security',
  'menu.cloak.account-login-history': 'Login History',
  'menu.cloak.account-preferences': 'Preferences',
  'menu.cloak.account-bindings': 'Account Bindings',
  // Ticket CDN-Oper
  'menu.cdn-oper.ticket': 'Ticket Center',
  'menu.cdn-oper.ticket.my-tickets': 'My Tickets',
  'menu.cdn-oper.ticket.my-tickets-list': 'Ticket List',
  'menu.cdn-oper.ticket.my-tickets-create': 'Create Ticket',
  'menu.cdn-oper.ticket.my-tickets-detail': 'Ticket Detail',
  'menu.cdn-oper.ticket.my-tickets-edit': 'Edit Ticket',
  'menu.cdn-oper.ticket.admin': 'Ticket Management',
  'menu.cdn-oper.ticket.admin-tickets': 'Ticket Management',
  'menu.cdn-oper.ticket.admin-ticket-detail': 'Ticket Detail',
  'menu.cdn-oper.ticket.admin-ticket-edit': 'Edit Ticket',
  'menu.cdn-oper.ticket.statistics': 'Statistics',
  'menu.cdn-oper.ticket.basic-settings': 'Basic Settings',
  'menu.cdn-oper.ticket.settings.org-category': 'Organization',
  'menu.cdn-oper.ticket.settings.categories': 'Categories',
  'menu.cdn-oper.ticket.settings.tags': 'Tags',
  'menu.cdn-oper.ticket.settings.team-fields': 'Team & Fields',
  'menu.cdn-oper.ticket.settings.teams': 'Teams',
  'menu.cdn-oper.ticket.settings.custom-fields': 'Custom Fields',
  'menu.cdn-oper.ticket.settings.form-templates': 'Forms & Templates',
  'menu.cdn-oper.ticket.settings.ticket-forms': 'Ticket Forms',
  'menu.cdn-oper.ticket.settings.ticket-templates': 'Ticket Templates',
  'menu.cdn-oper.ticket.settings.business-config': 'Business Config',
  'menu.cdn-oper.ticket.settings.canned-responses': 'Canned Responses',
  'menu.cdn-oper.ticket.settings.business-hours': 'Business Hours',
  'menu.cdn-oper.ticket.strategy': 'Service Strategy',
  'menu.cdn-oper.ticket.strategy.slas': 'SLA Policies',
  'menu.cdn-oper.ticket.strategy.workflows': 'Workflows',
  'menu.cdn-oper.ticket.strategy.automation-rules': 'Automation Rules',
  'menu.cdn-oper.ticket.strategy.escalation-rules': 'Escalation Rules',
  'menu.cdn-oper.ticket.logs': 'Logs & Audit',
  'menu.cdn-oper.ticket.logs.notification-rules': 'Notification Rules',
  'menu.cdn-oper.ticket.logs.spam-rules': 'Spam Rules',
  'menu.cdn-oper.ticket.logs.satisfactions': 'Satisfaction',
  'menu.cdn-oper.ticket.logs.notification-logs': 'Notification Logs',
  'menu.cdn-oper.ticket.logs.escalation-logs': 'Escalation Logs',
  'menu.cdn-oper.ticket.logs.automation-logs': 'Automation Logs',
  // Ticket
  'menu.ticket': 'Ticket',
  'menu.ticket.my-tickets': 'My Tickets',
  'menu.ticket.tenant-tickets': 'Ticket Management',
  'menu.ticket.slas': 'SLA Policies',
  'menu.ticket.workflows': 'Workflows',
  'menu.ticket.automation-rules': 'Automation Rules',
  'menu.ticket.escalation-rules': 'Escalation Rules',
  'menu.ticket.custom-fields': 'Custom Fields',
  'menu.ticket.teams': 'Teams',
  'menu.ticket.categories': 'Categories',
  'menu.ticket.tags': 'Tags',
  'menu.ticket.canned-responses': 'Canned Responses',
  'menu.ticket.notification-rules': 'Notification Rules',
  'menu.ticket.spam-rules': 'Spam Rules',
  'menu.ticket.ticket-forms': 'Ticket Forms',
  'menu.ticket.ticket-templates': 'Ticket Templates',
  'menu.ticket.business-hours': 'Business Hours',
  'menu.ticket.statistics': 'Statistics',
  'menu.ticket.satisfactions': 'Satisfaction',
  'menu.ticket.notification-logs': 'Notification Logs',
  'menu.ticket.escalation-logs': 'Escalation Logs',
  'menu.ticket.automation-logs': 'Automation Logs',
};
